const ListMesesBimestral = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'Enero/Febrero',
    value: '13'
  },
  {
    label: 'Marzo/Abril',
    value: '14'
  },
  {
    label: 'Mayo/Junio',
    value: '15'
  },
  {
    label: 'Julio/Agosto',
    value: '16'
  },
  {
    label: 'Septiembre/Octubre',
    value: '17'
  },
  {
    label: 'Noviembre/Diciembre',
    value: '18'
  },
];

export default ListMesesBimestral;